import React from 'react';

import { ErrorMessage } from '@eika/attention-message';

import useCounterValue from '../../../fetchHooks/useCounterValue';
import type { Currency } from '../../../generated-types';
import useTranslation from '../../../hooks/useTranslation';
import CurrencyExchangeDescription from './CurrencyExchangeDescription';

interface Props {
    selectedCurrency?: Currency;
    amount: number;
    calculatedCurrencyExchange?: (value: number) => void;
}

const CurrencyExchange: React.FC<Props> = ({ selectedCurrency, amount, calculatedCurrencyExchange }) => {
    const translated = useTranslation();
    const { data: currencyExchangeResult, error } = useCounterValue(amount, selectedCurrency, (data) =>
        calculatedCurrencyExchange?.(data.amount),
    );

    if (error) {
        return (
            <ErrorMessage
                className="currency-exchange-rate__error"
                text={translated.crossBorderPayment.currencyExchangeError}
            />
        );
    }

    return (
        <>
            <CurrencyExchangeDescription
                label={translated.crossBorderPayment.calculatedExchangeRate}
                value={currencyExchangeResult?.amount}
            />
            <CurrencyExchangeDescription
                label={translated.crossBorderPayment.exchangeRate}
                value={currencyExchangeResult?.exchangeRate}
                className="currency-exchange-description__exchange-rate"
            />
        </>
    );
};

export default CurrencyExchange;
